import { useEffect, useMemo, useState } from 'react';
import { catalogoAPI } from '../services/api.js';

let cachedTipos = null;
let inflight = null;

/**
 * Catálogo de tipos de actuación/formación desde BBDD (`GET /catalogo/tipos-formacion-actuacion`).
 * Respuesta deduplicada en memoria para no repetir peticiones entre pantallas.
 */
export function useTiposFormacionCatalogo() {
  const [tipos, setTipos] = useState(() => cachedTipos || []);
  const [loading, setLoading] = useState(!cachedTipos);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cachedTipos) {
      setTipos(cachedTipos);
      setLoading(false);
      return;
    }
    if (inflight) {
      inflight
        .then((data) => {
          setTipos(data);
          setLoading(false);
        })
        .catch((e) => {
          setError(e);
          setLoading(false);
        });
      return;
    }
    setLoading(true);
    inflight = catalogoAPI
      .getTiposFormacionActuacion()
      .then((res) => {
        const data = Array.isArray(res?.data) ? res.data : [];
        cachedTipos = data;
        inflight = null;
        return data;
      })
      .catch((e) => {
        inflight = null;
        throw e;
      });
    inflight
      .then((data) => {
        setTipos(data);
        setLoading(false);
      })
      .catch((e) => {
        setError(e);
        setLoading(false);
      });
  }, []);

  const byCodigo = useMemo(() => {
    const m = new Map();
    for (const t of tipos) {
      const c = String(t?.codigo ?? '')
        .trim()
        .toUpperCase();
      if (c) m.set(c, t);
    }
    return m;
  }, [tipos]);

  return { tipos, byCodigo, loading, error };
}
